import fuel_management from '@/app/[locale]/common/assets/images/projects/fuel-managment.webp';
import refueling_monitoring_remaining_fuel from '@/app/[locale]/common/assets/images/projects/refueling-monitoring-remaining-fuel.webp';
import alternator_engine_parameter from '@/app/[locale]/common/assets/images/projects/alternator-engine-parameter.webp';

import {APP_ROUTES} from "../app";


export const PROJECTS_PAGE_LABELS = {
    OUR_PROJECTS: 'Our Projects',
};

export const PROJECTS_PAGE_BREAD_CRUMB_CONTENT = {
    PROJECTS: {title: 'Projects', href: APP_ROUTES.PROJECTS},
};

export const PROJECTS_PAGE_CARDS_CONTENT = [
    {
        title: 'Fuel management for standby gensets in banks',
        task: 'Fuel monitoring, control of generator operating time and its fuel efficiency.',
        solution: 'DFM 500D CAN',
        image: fuel_management,
    },
    {
        title: 'Monitoring of refueling and remaining fuel',
        task: 'Online monitoring of the volume of fuel filling in a stationary fuel tank, as well as the total volume of fuel in tanks.',
        solution: 'DUT-E 2Bio differential fuel level sensors and KANUp telematisse gateways.',
        image: refueling_monitoring_remaining_fuel,
    },
    {
        title: 'Alternator and engine parameter remote monitoring',
        task: 'Providing backup power and remote control of generators',
        solution: 'DFM D fuel flow meters and CANUp Genset telematic gateways.',
        image: alternator_engine_parameter,
    },
];